<div class="job-order-data-state-filter-container">
  <button
    mat-stroked-button
    color="accent"
    class="btn"
    (click)="onViewAllSelected()"
  >
    View all selected
  </button>
  <form class="job-order-data-state-filter-form" [formGroup]="formGroup">
    <mat-label>Filters</mat-label>
    <mat-form-field>
      <input
        matInput
        placeholder="File name"
        formControlName="fileName"
        minlength="1"
      />
    </mat-form-field>

    <mat-label>Filter on date</mat-label>

    <mat-radio-group matInput formControlName="date" (change)="onChange()">
      <mat-radio-button value="THIS_YEAR">This year</mat-radio-button>
      <mat-radio-button value="THIS_MONTH">This month</mat-radio-button>
      <mat-radio-button value="TODAY">Today</mat-radio-button>
      <mat-radio-button value="CUSTOM">Custom</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="outline">
      <input
        placeholder="From date"
        matInput
        [matDatepicker]="fromDate"
        formControlName="fromDate"
      />
      <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
      <mat-datepicker #fromDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <input
        placeholder="To date"
        matInput
        [matDatepicker]="toDate"
        formControlName="toDate"
      />
      <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
      <mat-datepicker #toDate></mat-datepicker>
    </mat-form-field>

    <button
      [disabled]="!formGroup.valid || disableApply"
      mat-stroked-button
      color="accent"
      class="btn"
      (click)="onApply()"
    >
      Apply
    </button>
  </form>
</div>
